import { gql } from '@apollo/client';

export const DUPLICATE_OVERTIME = gql`
  mutation DuplicateOvertime($input: DuplicateOvertimeInput!) {
    duplicateOvertime(input: $input) {
      id
    }
  }
`;
